import React, { FC, useEffect, useState } from 'react'
import { DropdownButton, Form, ListGroup } from 'react-bootstrap'
import { UserType } from 'types'
import { styles } from './styles'
import { useTemplatesForProject } from 'hooks/useTemplatesForProject'
import { defaultTemplateId } from 'utils/constants'

export type FolderSelectionProps = {
  userType: UserType
  projectId?: number | undefined
  templateDocumentId?: number | undefined
  selectedFolder?: number[]
  onSelectionHandler?: any
}

export const FolderSelection: FC<FolderSelectionProps> = ({
  userType,
  projectId,
  templateDocumentId,
  onSelectionHandler,
  selectedFolder = [],
}) => {
  const localTemplates = useTemplatesForProject(projectId)
  const [selectedIds, setSelectedIds] = useState<any>([])

  let folderIds: number[] = []
  localTemplates.forEach(temp => {
    if (temp.isDirectory) {
      folderIds.push(temp.id)
    }
  })

  useEffect(() => {
    if (templateDocumentId === defaultTemplateId) {
      setSelectedIds(folderIds)
    } else {
      if (folderIds?.length) {
        setSelectedIds(
          folderIds?.filter((id: number | undefined) => id == templateDocumentId),
        )
      }
    }
  }, [templateDocumentId])

  useEffect(() => {
    onSelectionHandler(selectedIds)
  }, [onSelectionHandler, selectedIds])

  const onSelectFolderHandler = (template: any) => {
    let templateIds: any[] = [...selectedIds]

    if (templateIds.includes(template.id)) {
      let itemIndex = templateIds.indexOf(template.id)
      templateIds.splice(itemIndex, 1)
    } else {
      templateIds.push(template.id)
    }

    setSelectedIds(templateIds)
  }
  return (
    <DropdownButton
      title={`${selectedFolder?.length && folderIds?.length === selectedFolder?.length
          ? 'All'
          : selectedFolder?.length
        } Selected Folder`}
      id="user-select"
      style={styles.dropdownButton}>
      <Form>
        <div
          key={`inline-checkbox`}
          style={styles.folderSelection}
          className="mb-3">
          <ListGroup as="ul" style={styles.listGroup}>
            {localTemplates?.map(template => {
              return (
                template.isDirectory && (
                  <>
                    <ListGroup.Item
                      style={styles.listGroupItem}
                      as="li"
                      // active={isActive(template)}
                      key={template.id}
                      onClick={() => onSelectFolderHandler(template)}>
                      <Form.Check
                        inline
                        name="group1"
                        type="checkbox"
                        id={`inline-checkbox-1`}
                        checked={selectedIds.includes(template.id)}
                      />
                      <img
                        alt='folder-icon'
                        style={{ height: '20px', width: '20px' }}
                        src="https://www.clipartmax.com/png/small/364-3646106_240-%C3%97-240-pixels-folder-icon-flat-svg.png"
                      />
                      <span style={{ padding: '10px' }}>{template.name}</span>
                    </ListGroup.Item>
                  </>
                )
              )
            })}
          </ListGroup>
        </div>
      </Form>
    </DropdownButton>
  )
}
